export default {
  identifyUser: user => dispatch => {
    const userId = user.uid;
    const { email, metadata, emailVerified, isAnonymous } = user;
    dispatch({
      type: 'IDENTIFY_USER',
      user: {
        userId,
        email,
        metadata,
        emailVerified,
        isAnonymous,
      },
    });
  },
};
